export default __webpack_public_path__ + "img/shape-square.4e41a949.svg";